/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var gramaticaXMLASC = (function(){
var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[1,7],$V1=[6,7],$V2=[1,11],$V3=[14,20],$V4=[1,16],$V5=[14,17,20],$V6=[1,48],$V7=[1,49],$V8=[1,31],$V9=[1,27],$Va=[1,28],$Vb=[1,29],$Vc=[1,30],$Vd=[1,32],$Ve=[1,33],$Vf=[1,34],$Vg=[1,35],$Vh=[1,36],$Vi=[1,37],$Vj=[1,38],$Vk=[1,39],$Vl=[1,40],$Vm=[1,41],$Vn=[1,42],$Vo=[1,43],$Vp=[1,44],$Vq=[1,45],$Vr=[1,46],$Vs=[1,47],$Vt=[1,50],$Vu=[7,9,10,12,17,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44];
var parser = {trace: function trace () { },
yy: {},
symbols_: {"error":2,"INICIO":3,"ENCABEZADO":4,"RAICES":5,"EOF":6,"menor":7,"interr_cierra":8,"xml":9,"version":10,"igual":11,"cadena":12,"encoding":13,"mayor":14,"RAIZ":15,"OBJETO":16,"identificador":17,"LISTAATRIBUTOS":18,"OBJETOS":19,"division":20,"LISTA_TEXTO":21,"ATRIBUTOS":22,"ATRIBUTO":23,"IDENTIFICADOR":24,"alfanumerico":25,"numero":26,"decimal":27,"caracter":28,"less_than":29,"greater_than":30,"ampersand":31,"apostrophe":32,"quotation_mark":33,"mas":34,"menos":35,"coma":36,"ptcoma":37,"punto":38,"parizq":39,"parder":40,"apostofre":41,"dos_puntos":42,"numeral":43,"ecoding":44,"$accept":0,"$end":1},
terminals_: {2:"error",6:"EOF",7:"menor",8:"interr_cierra",9:"xml",10:"version",11:"igual",12:"cadena",13:"encoding",14:"mayor",17:"identificador",20:"division",25:"alfanumerico",26:"numero",27:"decimal",28:"caracter",29:"less_than",30:"greater_than",31:"ampersand",32:"apostrophe",33:"quotation_mark",34:"mas",35:"menos",36:"coma",37:"ptcoma",38:"punto",39:"parizq",40:"parder",41:"apostofre",42:"dos_puntos",43:"numeral",44:"ecoding"},
productions_: [0,[3,3],[4,11],[5,2],[5,1],[15,1],[16,9],[16,9],[16,5],[18,1],[18,0],[22,2],[22,1],[23,3],[21,2],[21,1],[24,1],[24,1],[24,1],[24,1],[24,1],[24,1],[24,1],[24,1],[24,1],[24,1],[24,1],[24,1],[24,1],[24,1],[24,1],[24,1],[24,1],[24,1],[24,1],[24,1],[24,1],[24,1],[24,1],[24,1],[19,2],[19,1]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */

var $0 = $$.length - 1;
switch (yystate) {
case 1:
 this.$ = $$[$0-1]; ListaReporteGrl.push("INICIO -> ENCABEZADO RAICES" + "," + "ENCABEZADO.VAL, RAICES.VAL");
										var nodos = this.$; var ecod = $$[$0-2]; var listRepor = ListaReporteGrl; var err = ListaErrores; 
										return {objetos:nodos, ecoding:ecod, listaRG:listRepor, errores:err};  
break;
case 2:
this.$ = $$[$0-2]; ListaReporteGrl.push("ENCABEZADO -> '<' '?' xml version '=' cadena encoding '=' cadena '?' '>'" + "," + "'<' '?' xml version '=' cadena encoding '=' cadena '?' '>'");
break;
case 3:
 $$[$0-1].push($$[$0]); this.$ = $$[$0-1]; ListaReporteGrl.push("RAICES -> RAICES RAIZ" + "," + "RAICES'.VAL = RAICES.VAL"); 
break;
case 4:
 this.$ = [$$[$0]]; ListaReporteGrl.push("RAICES -> RAIZ" + "," + "RAICES.VAL = RAIZ.VAL"); 
break;
case 5:
 this.$ = $$[$0]; ListaReporteGrl.push("RAIZ -> OBJETO" + "," + "RAIZ.VAL = OBJETO.VAL"); 
break;
case 6:
 this.$ = new Objeto($$[$0-7],'',_$[$0-8].first_line, _$[$0-8].first_column,$$[$0-6],$$[$0-4]); ListaReporteGrl.push("OBJETO -> menor identificador LISTAATRIBUTOS mayor OBJETOS menor division identificador mayor" + "," + "OBJETO.VAL = LISTAOBJETOS.ADD(OBJETO)"); 
break;
case 7:
 this.$ = new Objeto($$[$0-7],$$[$0-4],_$[$0-8].first_line, _$[$0-8].first_column,$$[$0-6],[]); ListaReporteGrl.push("OBJETO -> menor identificador LISTAATRIBUTOS mayor LISTA_TEXTO menor division identificador mayor" + "," + "OBJETO.VAL = LISTAATRIBUTOS.ADD(ATRIBUTO) + LISTA_TEXTO.VAL"); 
break;
case 8:
 this.$ = new Objeto($$[$0-3],'',_$[$0-4].first_line, _$[$0-4].first_column,$$[$0-2],[]); ListaReporteGrl.push("OBJETO -> menor identificador LISTAATRIBUTOS division mayor" + "," + "OBJETO.VAL = LISTAATRIBUTOS.ADD(ATRIBUTO)"); 
break;
case 9:
 this.$ = $$[$0]; ListaReporteGrl.push("LISTAATRIBUTOS -> ATRIBUTOS" + "," + "LISTAATRIBUTOS.VAL = ATRIBUTOS.VAL"); 
break;
case 10:
 this.$ = []; ListaReporteGrl.push("LISTAATRIBUTOS -> e" + "," + "e"); 
break;
case 11:
 $$[$0-1].push($$[$0]); this.$ = $$[$0-1]; ListaReporteGrl.push("ATRIBUTOS -> ATRIBUTOS ATRIBUTO" + "," + "ATRIBUTOS'.VAL = ATRIBUTOS.VAL"); 
break;
case 12:
 this.$ = [$$[$0]]; ListaReporteGrl.push("ATRIBUTOS -> ATRIBUTO" + "," + "ATRIBUTOS.VAL = ATRIBUTOS.VAL"); 
break;
case 13:
 this.$ = new Atributo($$[$0-2], $$[$0], _$[$0-2].first_line, _$[$0-2].first_column); ListaReporteGrl.push("ATRIBUTO -> identificador igual cadena" + "," + "ATRIBUTO.VAL = cadena.lexval"); 
break;
case 14:
 $$[$0-1]=$$[$0-1] + ' ' +$$[$0] ; this.$ = $$[$0-1]; ListaReporteGrl.push("LISTA_TEXTO -> LISTA_TEXTO IDENTIFICADOR" + "," + "LISTA_TEXTO'.VAL = LISTA_TEXTO.VAL"); 
break;
case 15:
 this.$ = $$[$0]; ListaReporteGrl.push("LISTA_TEXTO -> IDENTIFICADOR" + "," + "LISTA_TEXTO.VAL = IDENTIFICADOR.VAL"); 
break;
case 16:
 this.$ = $$[$0]; ListaReporteGrl.push("IDENTIFICADOR -> identificador" + "," + "IDENTIFICADOR.val = identificador.lexval"); 
break;
case 17:
 this.$ = $$[$0]; ListaReporteGrl.push("IDENTIFICADOR -> alfanumerico" + "," + "IDENTIFICADOR.val = alfanumerico.lexval"); 
break;
case 18:
 this.$ = $$[$0]; ListaReporteGrl.push("IDENTIFICADOR -> numero" + "," + "IDENTIFICADOR.val = numero.lexval"); 
break;
case 19:
 this.$ = $$[$0]; ListaReporteGrl.push("IDENTIFICADOR -> decimal" + "," + "IDENTIFICADOR.val = decimal.lexval"); 
break;
case 20:
 this.$ = $$[$0]; ListaReporteGrl.push("IDENTIFICADOR -> cadena" + "," + "IDENTIFICADOR.val = cadena.lexval"); 
break;
case 21:
 this.$ = $$[$0]; ListaReporteGrl.push("IDENTIFICADOR -> caracter" + "," + "IDENTIFICADOR.val = caracter.lexval"); 
break;
case 22:
 $$[$0] = "<"; this.$ = $$[$0]; ListaReporteGrl.push("IDENTIFICADOR -> less_than" + "," + "IDENTIFICADOR.val = less_than.val, less_than.lexval = &lt;"); 
break;
case 23:
 $$[$0] = ">"; this.$ = $$[$0]; ListaReporteGrl.push("IDENTIFICADOR -> greater_than" + "," + "IDENTIFICADOR.val = greater_than.val, greater_than.lexval = &gt;"); 
break;
case 24:
 $$[$0] = "&"; this.$ = $$[$0]; ListaReporteGrl.push("IDENTIFICADOR -> ampersand" + "," + "IDENTIFICADOR.val = ampersand.val, ampersand.lexval = &amp;"); 
break;
case 25:
 $$[$0] = "\'"; this.$ = $$[$0]; ListaReporteGrl.push("IDENTIFICADOR -> apostrophe" + "," + "IDENTIFICADOR.val = apostrophe.val, apostrophe.lexval = &apos;"); 
break;
case 26:
 $$[$0] = "\""; this.$ = $$[$0]; ListaReporteGrl.push("IDENTIFICADOR -> quotation_mark" + "," + "IDENTIFICADOR.val = quotation_mark.val, quotation_mark.lexval = &quot;");
break;
case 27: case 28: case 29: case 30: case 31: case 32: case 33: case 34: case 35: case 36: case 37: case 38: case 39:
this.$ = $$[$0]; ListaReporteGrl.push("IDENTIFICADOR -> simbolo" + "," + "IDENTIFICADOR.val = simbolo.lexval");
break;
case 40:
 $$[$0-1].push($$[$0]); this.$ = $$[$0-1]; ListaReporteGrl.push("OBJETOS -> OBJETOS OBJETO" + "," + "OBJETOS'.VAL = OBJETOS.VAL"); 
break;
case 41:
 this.$ = [$$[$0]]; ListaReporteGrl.push("OBJETOS -> OBJETO" + "," + "OBJETOS.VAL = OBJETO.VAL"); 
break;
}
},
table: [{3:1,4:2,7:[1,3]},{1:[3]},{5:4,7:$V0,15:5,16:6},{8:[1,8]},{6:[1,9],7:$V0,15:10,16:6},o($V1,[2,4]),o($V1,[2,5]),{17:$V2},{9:[1,12]},{1:[2,1]},o($V1,[2,3]),o($V3,[2,10],{18:13,22:14,23:15,17:$V4}),{10:[1,17]},{14:[1,18],20:[1,19]},o($V3,[2,9],{23:20,17:$V4}),o($V5,[2,12]),{11:[1,21]},{11:[1,22]},{7:$V0,9:$V6,10:$V7,12:$V8,16:25,17:$V9,19:23,21:24,24:26,25:$Va,26:$Vb,27:$Vc,28:$Vd,29:$Ve,30:$Vf,31:$Vg,32:$Vh,33:$Vi,34:$Vj,35:$Vk,36:$Vl,37:$Vm,38:$Vn,39:$Vo,40:$Vp,41:$Vq,42:$Vr,43:$Vs,44:$Vt},{14:[1,51]},o($V5,[2,11]),{12:[1,52]},{12:[1,53]},{7:[1,54],16:55},{7:[1,56],9:$V6,10:$V7,12:$V8,17:$V9,24:57,25:$Va,26:$Vb,27:$Vc,28:$Vd,29:$Ve,30:$Vf,31:$Vg,32:$Vh,33:$Vi,34:$Vj,35:$Vk,36:$Vl,37:$Vm,38:$Vn,39:$Vo,40:$Vp,41:$Vq,42:$Vr,43:$Vs,44:$Vt},{7:[2,41]},o($Vu,[2,15]),o($Vu,[2,16]),o($Vu,[2,17]),o($Vu,[2,18]),o($Vu,[2,19]),o($Vu,[2,20]),o($Vu,[2,21]),o($Vu,[2,22]),o($Vu,[2,23]),o($Vu,[2,24]),o($Vu,[2,25]),o($Vu,[2,26]),o($Vu,[2,27]),o($Vu,[2,28]),o($Vu,[2,29]),o($Vu,[2,30]),o($Vu,[2,31]),o($Vu,[2,32]),o($Vu,[2,33]),o($Vu,[2,34]),o($Vu,[2,35]),o($Vu,[2,36]),o($Vu,[2,37]),o($Vu,[2,38]),o($Vu,[2,39]),o($V1,[2,8]),o($V5,[2,13]),{13:[1,58]},{17:$V2,20:[1,59]},{7:[2,40]},{20:[1,60]},o($Vu,[2,14]),{11:[1,61]},{17:[1,62]},{17:[1,63]},{12:[1,64]},{14:[1,65]},{14:[1,66]},{8:[1,67]},o($V1,[2,6]),o($V1,[2,7]),{14:[1,68]},{7:[2,2]}],
defaultActions: {9:[2,1],25:[2,41],55:[2,40],68:[2,2]},
parseError: function parseError (str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        var error = new Error(str);
        error.hash = hash;
        throw error;
    }
},
parse: function parse(input) {
    var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    var args = lstack.slice.call(arguments, 1);
    var lexer = Object.create(this.lexer);
    var sharedState = { yy: {} };
    for (var k in this.yy) {
        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
            sharedState.yy[k] = this.yy[k];
        }
    }
    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);
    var ranges = lexer.options && lexer.options.ranges;
    if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
    _token_stack:
        var lex = function () {
            var token;
            token = lexer.lex() || EOF;
            if (typeof token !== 'number') {
                token = self.symbols_[token] || token;
            }
            return token;
        };
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
                    if (typeof action === 'undefined' || !action.length || !action[0]) {
                var errStr = '';
                expected = [];
                for (p in table[state]) {
                    if (this.terminals_[p] && p > TERROR) {
                        expected.push('\'' + this.terminals_[p] + '\'');
                    }
                }
                if (lexer.showPosition) {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
                } else {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
                }
                this.parseError(errStr, {
                    text: lexer.match,
                    token: this.terminals_[symbol] || symbol,
                    line: lexer.yylineno,
                    loc: yyloc,
                    expected: expected
                });
            }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(lexer.yytext);
            lstack.push(lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = lexer.yyleng;
                yytext = lexer.yytext;
                yylineno = lexer.yylineno;
                yyloc = lexer.yylloc;
                if (recovering > 0) {
                    recovering--;
                }
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {
                first_line: lstack[lstack.length - (len || 1)].first_line,
                last_line: lstack[lstack.length - 1].last_line,
                first_column: lstack[lstack.length - (len || 1)].first_column,
                last_column: lstack[lstack.length - 1].last_column
            };
            if (ranges) {
                yyval._$.range = [
                    lstack[lstack.length - (len || 1)].range[0],
                    lstack[lstack.length - 1].range[1]
                ];
            }
            r = this.performAction.apply(yyval, [
                yytext,
                yyleng,
                yylineno,
                sharedState.yy,
                action[1],
                vstack,
                lstack
            ].concat(args));
            if (typeof r !== 'undefined') {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}};


	var ListaErrores=[];
	var ListaReporteGrl=[];
 
    const {Objeto} = require("../Expresiones/Objeto");
    const {Atributo} = require("../Expresiones/Atributo");
/* generated by jison-lex 0.3.4 */
var lexer = (function(){
var lexer = ({

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function(match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex () {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin (condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState () {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules () {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState (n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState (condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {"case-insensitive":true},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0:this.begin("Comentario"); 
break;
case 1:
break;
case 2:
break;
case 3:this.popState();
break;
case 4:console.log("comentario: "+yy_.yytext)
break;
case 5:/* skip whitespace */
break;
case 6:return 34;
break;
case 7:return 35;
break;
case 8:return 'por';
break;
case 9:return 20;
break;
case 10:return 'menor_igual';
break;
case 11:return 'mayor_igual';
break;
case 12:return 7;
break;
case 13:return 14;
break;
case 14:return 11;
break;
case 15:return 37;
break;
case 16:return 38;
break;
case 17:return 36;
break;
case 18:return 39;
break;
case 19:return 40;
break;
case 20:return 8;
break;
case 21:return 41		
break;
case 22:return 42
break;
case 23:return 43
break;
case 24:return 9;
break;
case 25:return 10;
break;
case 26:return 13;
break;
case 27:return'less_than';
break;
case 28:return'greater_than';
break;
case 29:return'ampersand';
break;
case 30:return'apostrophe';
break;
case 31:return'quotation_mark';
break;
case 32:return 12
break;
case 33:return 28
break;
case 34:return 17;
break;
case 35:return 25
break;
case 36:return 27;
break;
case 37:return 26;
break;
case 38:
										ListaErrores.push('Error Lexico,' + yy_.yytext + ',' + yy_.yylloc.first_line + ',' + yy_.yylloc.first_column);
                                    
break;
case 39:return 6
break;
}
},
rules: [/^(?:<!--)/i,/^(?:[ \r\t]+)/i,/^(?:\n)/i,/^(?:-->)/i,/^(?:[^"-->"]+)/i,/^(?:\s+)/i,/^(?:\+)/i,/^(?:-)/i,/^(?:\*)/i,/^(?:\/)/i,/^(?:<=)/i,/^(?:>=)/i,/^(?:<)/i,/^(?:>)/i,/^(?:=)/i,/^(?:;)/i,/^(?:\.)/i,/^(?:,)/i,/^(?:\()/i,/^(?:\))/i,/^(?:\?)/i,/^(?:')/i,/^(?::)/i,/^(?:#)/i,/^(?:xml\b)/i,/^(?:version\b)/i,/^(?:encoding\b)/i,/^(?:&lt;)/i,/^(?:&gt;)/i,/^(?:&amp;)/i,/^(?:&apos;)/i,/^(?:&quot;)/i,/^(?:("((\\([\'\"\\bfnrtv]))|([^\"\\]+))*"))/i,/^(?:('((\\([\'\"\\bfnrtv]))|([^\'\\]))'))/i,/^(?:[a-zA-Z_][a-zA-Z0-9_ñÑá-ü]*)/i,/^(?:([a-zA-Z0-9_-]){1,16})/i,/^(?:(([0-9]+\.[0-9]*)|(\.[0-9]+)))/i,/^(?:[0-9]+)/i,/^(?:.)/i,/^(?:$)/i],
conditions: {"comment":{"rules":[0,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39],"inclusive":true},"Etiqueta":{"rules":[],"inclusive":false},"Comentario":{"rules":[1,2,3,4],"inclusive":false},"INITIAL":{"rules":[0,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39],"inclusive":true}}
});
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();


if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
exports.parser = gramaticaXMLASC;
exports.Parser = gramaticaXMLASC.Parser;
exports.parse = function () { return gramaticaXMLASC.parse.apply(gramaticaXMLASC, arguments); };
exports.main = function commonjsMain (args) {
    if (!args[1]) {
        console.log('Usage: '+args[0]+' FILE');
        process.exit(1);
    }
    var source = require('fs').readFileSync(require('path').normalize(args[1]), "utf8");
    return exports.parser.parse(source);
};
if (typeof module !== 'undefined' && require.main === module) {
  exports.main(process.argv.slice(1));
}
}